<script setup>
import { computed, inject } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination } from 'swiper/modules';
import { useWindowSize } from '@vueuse/core';
const { width } = useWindowSize();
const modules = [Pagination];
const DLEvent = inject('DLEvent');
const items = [
  {title: 'Календарь <br/>прививок', link: '/dog/article/kalendar-privivok-dlya-shchenkov/'},
  {title: 'как понять <br/>щенка', link: '/dog/article/iazyk-tiela-kharaktiernyi-dlia-shchienkov-i-bazovyie-printsipy-vospitaniia/'},
  {title: 'почему собаки все грызут и&nbsp;как с&nbsp;этим справиться?', link: '/dog/article/pochiemu-sobaki-vsie-ghryzut-i-kak-s-etim-spravit-sia/'},
  {title: 'первые дни щенка <br/>в&nbsp;новом доме', link: '/dog/article/shchienok-odin-doma-riekomiendatsii/'},
]
const swiperOptions = computed(() => {
  return {
    modules: modules,
    slidesPerView: 'auto',
    spaceBetween: 16,
    centerInsufficientSlides: true,
    pagination: {
      clickable: true,
    }
  }
})
</script>
<template>
  <div class="useful-materials">
    <div class="useful-materials__inner">
      <h2 class="useful-materials__title">Полезные материалы</h2>
      <div class="useful-materials__items" v-if="width > 1023">
        <div class="useful-materials__item" v-for="(item, index) in items" :key="index">
          <img :src="require(`@/assets/img/material-img${index + 1}.png`)" alt="" />
          <p v-html="item.title"></p>
          <a
              :href="item.link"
              target="_blank"
              @click="DLEvent('puppyPage_article_click', 'article_URL', item.link)"
          >Подробнее</a>
        </div>
      </div>
      <Swiper
          v-else
          v-bind="swiperOptions"
          class="useful-materials__slider"
      >
        <SwiperSlide v-for="(item, index) in items" :key="index">
          <div class="useful-materials__item">
            <img :src="require(`@/assets/img/material-img${index + 1}.png`)" alt="" />
            <p v-html="item.title"></p>
            <a
                :href="item.link"
                target="_blank"
                @click="DLEvent('puppyPage_article_click', 'article_URL', item.link)"
            >Подробнее</a>
          </div>
        </SwiperSlide>
        <template #pagination></template>
      </Swiper>
    </div>
  </div>
</template>